<template>
  <div
    id="app"
    ref="app"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <HeaderComponent></HeaderComponent>
    <div id="module2Content">
      <!-- <keep-alive> -->
      <router-view></router-view>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>

<script>
import HeaderComponent from "./components/HeaderComponent.vue";
export default {
  name: "App",
  data() {
    return {
      style: {
        width: "",
        height: "",
        transform: "",
        overflowX: "",
        traslateX: "",
      },
    };
  },
  components: {
    HeaderComponent,
  },
  watch: {
    //刷新首页的合作案例的轮播图
    // $route: function (to) {
    //   console.log("路由发生变化", to.path, to.query, to.params);
    //   if (to.path == "/") {
    //     localStorage.removeItem("currentIndex"); //清除指定字段
    //     localStorage.setItem("currentName", 0);
    //     this.$bus.$emit("reload");
    //   } else if (to.path == "/productClound") {
    //     //定位复原
    //     this.$bus.$emit("productCloundReload");
    //   }
    //   switch (to.path) {
    //     case "/coretechnology":
    //       localStorage.removeItem("currentIndex"); //清除指定字段
    //       localStorage.setItem("currentName", 1);
    //       break;
    //     case "/aboutUs":
    //       localStorage.removeItem("currentIndex"); //清除指定字段
    //       localStorage.setItem("currentName", 4);
    //       break;
    //     case "/joinUs":
    //       localStorage.removeItem("currentIndex"); //清除指定字段
    //       localStorage.setItem("currentName", 5);
    //       break;
    //     // 产品中心
    //     case "/productGaiA":
    //       localStorage.setItem("currentName", 2);
    //       localStorage.setItem("currentIndex", 0);
    //       break;
    //     case "/productRHea":
    //       localStorage.setItem("currentName", 2);
    //       localStorage.setItem("currentIndex", 1);
    //       break;
    //     // case "/productHiL":
    //     //   localStorage.setItem("currentIndex", 2);
    //     //   break;
    //     case "/productRing":
    //       localStorage.setItem("currentName", 2);
    //       localStorage.setItem("currentIndex", 2);
    //       break;
    //     case "/productClound":
    //       localStorage.setItem("currentName", 2);
    //       localStorage.setItem("currentIndex", 3);
    //       break;
    //     case "/productMeiDuSha":
    //       localStorage.setItem("currentName", 2);
    //       localStorage.setItem("currentIndex", 4);
    //       break;
    //     case "/productHercules":
    //       localStorage.setItem("currentName", 2);
    //       localStorage.setItem("currentIndex", 5);
    //       break;
    //     //  生态圈
    //     case "/modelSharePlatform":
    //       localStorage.setItem("currentName", 3);
    //       localStorage.setItem("currentEcosphereIndex", 0);
    //       break;
    //     case "/ecologicalCooperationSharePlatform":
    //       localStorage.setItem("currentName", 3);
    //       localStorage.setItem("currentEcosphereIndex", 1);
    //       break;
    //     default:
    //       break;
    //   }
    // },
    // immediate: true, // 立即监听
    // deep: true,
  },
};

//禁用右键菜单
document.oncontextmenu = function (evt) {
  var e = evt || event;
  e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true);
  return false;
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

html,
body,
#app {
  height: 100%;
  /* 隐藏纵向滚动条 */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;

  /* 显示页面内容时出现滚动条 */

  /* IE 10+ */
  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }

  #module2Content {
    height: 100%;
  }
}

html,
body {
  box-sizing: border-box;
  background-color: #0c132b;
}

#app {
  &.en {
    * {
      letter-spacing: 0 !important;
    }
  }
}
</style>
